<script lang="ts">
  import { Form } from "../lib/validation_next";
  import { log } from "$shared/utils/misc";

  export let field: Form.MultiSelect<any>;
  export let label: string | undefined = undefined;
  export let customClass: string | undefined = undefined;
  export let customClassLabel: string | undefined = undefined;
  export let name: string = (Math.random()).toString();
  export let disabled = false;

  let input = field.input;

  const initialLabel = $input ?? "";
  log.info("ValSelect: initial label", initialLabel);
  let selectedLabel = initialLabel;

  $: selectedLabel, field.input.set(selectedLabel);

  field.output.subscribe((state) => {
    if (import.meta.env.DEV) console.log("output changed", state);
  });
  field.input.subscribe((state) => {
    if (import.meta.env.DEV) console.log("input changed", state);
    field.input.set(state);
    selectedLabel = state;
  });
  const choices = field.choices;
</script>

<div class={customClass}>
  {#if label}
    <label
      class="pb-[6px] text-[15px] block text-[#58686A] {customClassLabel}"
      for={name}
    >{label}</label>
  {/if}
  <div class="outset flex align-middle items-center input-field select-wrapper">
    <select
      {disabled}
      {name}
      id={name}
      bind:value={selectedLabel}
      class:error={false}
      class:isOk={true}
      class="flex-grow px-[16px] border-none outline-none h-[40px] !bg-transparent select"
    >
      {#each $choices as item, idx}
        <option
          id={`${name}-${idx}`}
          value={item.label}
          disabled={item.disabled}
          selected={selectedLabel === item.label}
        >
          {item.label}
        </option>
      {/each}
    </select>
  </div>
  <!-- 
  {#if error && hasChanged}
    <span class="pt-[8px] text-[15px] block text-[#C51C1C]">{error}</span>
  {/if}
-->
</div>

<style lang="postcss" scoped>
  .error {
    @apply bg-[#ffe6ea];
  }
  .isOk {
    @apply bg-[#ffffff];
  }
  .input-field {
    @apply min-w-[200px] border border-[#c5dedb] bg-[#ffffff] text-base
      font-medium rounded-[5px] text-[#181818] focus-within:outline-none
      focus-within:border-[#88c6bd] hover:border-[#58686a] transition-colors
      duration-100 cursor-text;
  }
  .input-warning {
    @apply !border-[#ec5e76] !bg-[#ffe6ea] !text-[#957677];
  }
  .select {
    -webkit-appearance: none;
    appearance: none;
    background-image: url("/icons/arrow-down.svg");
    background-repeat: no-repeat;
    background-position: calc(100% - 16px) center;
  }
</style>
